import {
  formatMoney,
  sanitizeFilenamePart
} from '../../../../helpers/utils'
import {
  resolveFillRateProductDisplayDifference
} from '../fillRateProductDifferencesFormatters'

const formatCsvDifference = (value) => {
  const amount = resolveFillRateProductDisplayDifference(value)

  if (amount === 0) return '="-"'
  if (amount > 0) return `="${formatMoney(amount)}"`

  return `="-${formatMoney(Math.abs(amount))}"`
}

const formatCsvSummaryDifference = (value) =>
  `="-${formatMoney(Math.abs(Number(value || 0)))}"`

const escapeCsvValue = (value) => {
  const normalized = value === null || value === undefined ? '' : String(value)

  if (/[",\n]/.test(normalized)) {
    return `"${normalized.replace(/"/g, '""')}"`
  }

  return normalized
}

const buildCsvContent = (rows) =>
  rows.map((row) => row.map(escapeCsvValue).join(',')).join('\n')

const downloadFillRateProductDifferencesCsv = (rows, filename) => {
  const csvContent = buildCsvContent(rows)
  const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' })
  const objectUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = objectUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(objectUrl)
}

export const buildFillRateProductDifferencesCsvFile = ({
  buyer,
  productGroupLabel,
  dateRangeLabel,
  productsWithDifferenceCount,
  differenceTotal,
  rows
}) => {
  const csvRows = []

  csvRows.push(['REPORTE:', `Productos con diferencias - ${buyer || 'N/A'}`])
  csvRows.push(['GENERADO:', new Date().toLocaleString('es-PA')])
  csvRows.push([''])
  csvRows.push(['RESUMEN'])
  csvRows.push([''])
  csvRows.push(['GRUPO DE PRODUCTOS', productGroupLabel || '-'])
  csvRows.push(['RANGO DE FECHA', dateRangeLabel || '-'])
  csvRows.push(['PRODUCTOS CON DIFERENCIA', String(productsWithDifferenceCount ?? 0)])
  csvRows.push(['DIFERENCIA TOTAL', formatCsvSummaryDifference(differenceTotal)])
  csvRows.push([''])
  csvRows.push([''])
  csvRows.push([
    'CÓDIGO',
    'CÓDIGO DE BARRA',
    'DESCRIPCIÓN',
    'MONTO OC',
    'MONTO PEDIDO',
    'DIFERENCIA'
  ])

  rows.forEach((row) => {
    csvRows.push([
      row.product_code || '-',
      row.product_barcode || '-',
      row.description || '-',
      formatMoney(row.purchase_order_total),
      formatMoney(row.order_total),
      formatCsvDifference(row.difference)
    ])
  })

  return csvRows
}

export const buildFillRateProductDifferencesFilename = ({
  buyer,
  productGroupLabel
}) =>
  `Productos_con_diferencias_${sanitizeFilenamePart(buyer)}_${sanitizeFilenamePart(productGroupLabel)}.csv`

export const exportFillRateProductDifferencesCsv = ({
  buyer,
  productGroupLabel,
  dateRangeLabel,
  productsWithDifferenceCount,
  differenceTotal,
  rows
}) => {
  downloadFillRateProductDifferencesCsv(
    buildFillRateProductDifferencesCsvFile({
      buyer,
      productGroupLabel,
      dateRangeLabel,
      productsWithDifferenceCount,
      differenceTotal,
      rows
    }),
    buildFillRateProductDifferencesFilename({
      buyer,
      productGroupLabel
    })
  )
}
